<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    :fullscreen="$vuetify.display.smAndDown"
    scrollable
    :retain-focus="false"
  >
    <v-card v-if="parts">
      <!-- Close Button -->
      <v-card-title class="redColor parts-qr-title">
        <div class="parts-qr-title-row d-flex align-center w-100">
          <span
            class="text-subtitle-1 font-weight-medium text-white parts-qr-title-label"
          >
            <strong>{{ $t("attention") }}!</strong>
          </span>
          <v-btn
            variant="outlined"
            size="small"
            icon
            color="white"
            class="parts-qr-close-btn flex-shrink-0"
            @click="close"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <p class="parts-qr-info text-body-2 text-white mb-0">
          {{ $t("scanned_qr_info") }}
        </p>
      </v-card-title>

      <v-card-text class="mt-4">
        <v-row>
          <!-- Loader -->
          <v-col
            v-if="loading"
            cols="12"
            class="d-flex justify-center align-center"
          >
            <v-progress-circular indeterminate color="red" />
          </v-col>

          <!-- Parts -->
          <v-col
            v-for="(part, index) in parts"
            v-else
            :key="index"
            cols="12"
            sm="6"
            md="3"
          >
            <v-card class="elevation-0">
              <v-row class="text-center">
                <v-col cols="12" class="pa-2 pt-4 text-center justify-center">
                  <qr-code
                    class="d-flex justify-center"
                    :size="150"
                    :text="part.id"
                  />
                </v-col>

                <v-col cols="12">
                  <v-row class="justify-center">
                    <h3 class="pt-2">
                      {{ part.id.slice(part.id.length - 6) }}
                    </h3>
                    <v-tooltip bottom>
                      <template #activator="{ on, attrs }">
                        <v-btn
                          icon
                          variant="text"
                          v-bind="attrs"
                          v-on="on"
                          @click="printSingle(part)"
                        >
                          <v-icon>
                            {{
                              part.printed ? "mdi-printer-off" : "mdi-printer"
                            }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span v-if="part.printed" class="d-flex align-center">
                        <v-icon small>mdi-printer-off</v-icon>
                        &nbsp; {{ $t("printed_alert") }}
                      </span>
                    </v-tooltip>
                  </v-row>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="parts-qr-actions pa-3">
        <v-spacer class="d-none d-md-flex" />
        <v-btn color="primary" variant="outlined" @click="print">
          {{ $t("parts.insert_parts.qr_codes.print_qr_codes") }}
          <v-icon end>mdi-printer</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VueQrCode from "vue-qr-generator"; // eslint-disable-line import/extensions
import QrCode from "qrcode";
import { Printd } from "printd";
import postRequest from "../../api/postRequest";
import getRequest from "../../api/getRequest";
import { formatVehicleFuelTransmissionLine } from "../../utils/vehicleQrLabel";

function printSingleQrCode(vehicle, supply, part, t) {
  QrCode.toDataURL(part.id, (error, url) => {
    // if (error) {
    //   console.log(error);
    // }

    const qrImage = document.createElement("img");
    qrImage.setAttribute("id", "qrImage");
    qrImage.setAttribute("src", url);
    qrImage.style.width = "100px";
    qrImage.style.height = "100px";
    const idDiv = document.createElement("div");
    const slicedId = part.id.slice(part.id.length - 6, part.id.length);
    idDiv.textContent = slicedId;
    idDiv.setAttribute("id", "idText");

    const row1 = document.createElement("div");
    row1.setAttribute("id", "carText");
    row1.textContent = `${vehicle.brand.title}`;

    const row2 = document.createElement("div");
    row2.setAttribute("id", "carText");
    const startingDate = vehicle.model.startingDate
      ? new Date(vehicle.model.startingDate)
      : null;
    const endingDate = vehicle.model.endingDate
      ? new Date(vehicle.model.endingDate)
      : null;
    row2.textContent = `${vehicle.model.description} ${startingDate ? `${startingDate.getMonth() + 1}/${startingDate.getFullYear()}` : ""} - ${endingDate ? `${endingDate.getMonth() + 1}/${endingDate.getFullYear()}` : ""}`;

    const row3 = document.createElement("div");
    row3.setAttribute("id", "carText");
    row3.textContent = vehicle.version.description;

    const row4 = document.createElement("div");
    row4.setAttribute("id", "carText");
    row4.textContent = `${vehicle.version.engineCode || ""} / ${vehicle.version.power.kw} kw / ${vehicle.km ? `${vehicle.km} km` : ""}`;

    const row5 = document.createElement("div");
    row5.setAttribute("id", "carText");
    row5.textContent = formatVehicleFuelTransmissionLine(vehicle, supply, t);

    const row6 = document.createElement("div");
    row6.setAttribute("id", "carText");
    row6.textContent = `PRA: ${vehicle.pra || ""}   ${vehicle.registrationYear ? `- ${vehicle.registrationYear}` : ""}`;

    const row7 = document.createElement("div");
    const date = vehicle.date_created ? vehicle.date_created.split("T")[0] : "";
    row7.setAttribute("id", "carText");
    row7.textContent = `VIN: ${vehicle.vin || ""} - DATE:${date}`;

    const table = document.createElement("table");
    table.setAttribute("class", "center");
    const tr = document.createElement("tr");

    const td1 = document.createElement("td");
    const td2 = document.createElement("td");

    td1.appendChild(idDiv);
    td1.appendChild(qrImage);

    td2.appendChild(row1);
    td2.appendChild(row2);
    td2.appendChild(row3);
    td2.appendChild(row4);
    td2.appendChild(row5);
    td2.appendChild(row6);
    td2.appendChild(row7);

    tr.appendChild(td1);
    tr.appendChild(td2);
    table.appendChild(tr);

    const css = [
      `
      @media print {
        @page {
          size: 10cm, 4cm;
          size: landscape;
        }
        body {
          height: 100%;
          width: 100%;
        }
        .hideOnPrint {
          display: none;
        }
        .center {
          margin-left: auto;
          margin-right: auto;
        }
        #qrImage {
          display: block;
          margin: 0 auto;
        }
        #idText {
          font-family: "Roboto";
          font-size: 18px;
          text-align: center;
          font-weight: bold;
          text-transform: uppercase;
        }
        #carText {
          font-family: "Roboto";
          font-size: 14px;
          text-align: left;
          font-weight: bold;
        }
      }
      `,
      "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons",
    ];

    const d = new Printd();
    return d.print(table, css, "", (callback) => {
      const { iframe, launchPrint } = callback;
      const { contentWindow } = iframe;
      contentWindow.addEventListener("afterprint", () => {
        postRequest.object("/print", { type: part.type, id: part.id });
      });
      launchPrint();
    });
  });
}

function printMultipleQrCodes(vehicle, supply, parts, t) {
  const table = document.createElement("table");
  table.setAttribute("class", "center");

  parts.forEach((part) => {
    QrCode.toDataURL(part.id, (error, url) => {
      // if (error) {
      //   console.log(error);
      // }

      const qrImage = document.createElement("img");
      qrImage.setAttribute("id", "qrImage");
      qrImage.setAttribute("src", url);
      qrImage.style.width = "100px";
      qrImage.style.height = "100px";
      const idDiv = document.createElement("div");
      const slicedId = part.id.slice(part.id.length - 6, part.id.length);
      idDiv.textContent = slicedId;
      idDiv.setAttribute("id", "idText");

      const row1 = document.createElement("div");
      row1.setAttribute("id", "carText");
      row1.textContent = vehicle.brand.title;

      const row2 = document.createElement("div");
      row2.setAttribute("id", "carText");
      const startingDate = vehicle.model.startingDate
        ? new Date(vehicle.model.startingDate)
        : null;
      const endingDate = vehicle.model.endingDate
        ? new Date(vehicle.model.endingDate)
        : null;
      row2.textContent = `${vehicle.model.description} ${startingDate ? `${startingDate.getMonth() + 1}/${startingDate.getFullYear()}` : ""} - ${endingDate ? `${endingDate.getMonth() + 1}/${endingDate.getFullYear()}` : ""}`;

      const row3 = document.createElement("div");
      row3.setAttribute("id", "carText");
      row3.textContent = vehicle.version.description;

      const row4 = document.createElement("div");
      row4.setAttribute("id", "carText");
      row4.textContent = `${vehicle.version.engineCode || ""} / ${vehicle.version.power.kw} kw / ${vehicle.km ? `${vehicle.km} km` : ""}`;

      const row5 = document.createElement("div");
      row5.setAttribute("id", "carText");
      row5.textContent = formatVehicleFuelTransmissionLine(vehicle, supply, t);

      const row6 = document.createElement("div");
      row6.setAttribute("id", "carText");
      row6.textContent = `PRA: ${vehicle.pra || ""}   ${vehicle.registrationYear ? `- ${vehicle.registrationYear}` : ""}`;

      const row7 = document.createElement("div");
      const date = vehicle.date_created
        ? vehicle.date_created.split("T")[0]
        : "";
      row7.setAttribute("id", "carText");
      row7.textContent = `VIN: ${vehicle.vin || ""} - DATE:${date}`;

      const tr1 = document.createElement("tr");
      tr1.setAttribute("class", "spacer");

      const td1 = document.createElement("td");
      const td2 = document.createElement("td");

      td1.appendChild(idDiv);
      td1.appendChild(qrImage);

      td2.appendChild(row1);
      td2.appendChild(row2);
      td2.appendChild(row3);
      td2.appendChild(row4);
      td2.appendChild(row5);
      td2.appendChild(row6);
      td2.appendChild(row7);

      tr1.appendChild(td1);
      tr1.appendChild(td2);
      table.appendChild(tr1);
    });
  });

  const css = [
    `
    @media print {
      @page {
        size: 10cm, 4cm;
        size: landscape;
      }
      body {
        height: 100%;
        width: 100%;
      }
      .hideOnPrint {
        display: none;
      }
      .center {
        margin-left: auto;
        margin-right: auto;
      }
      .spacer {
        padding-top: 5px;
        padding-bottom: 5px;
      }
      #qrImage {
        display: block;
        margin: 0 auto;
      }
      #idText {
        font-family: "Roboto";
        font-size: 18px;
        text-align: center;
        font-weight: bold;
        text-transform: uppercase;
      }
      #carText {
        font-family: "Roboto";
        font-size: 14px;
        text-align: left;
        font-weight: bold;
      }
    }
    `,
    "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Material+Icons",
  ];

  const d = new Printd();
  return d.print(table, css, "", (callback) => {
    const { iframe, launchPrint } = callback;
    const { contentWindow } = iframe;
    contentWindow.addEventListener("afterprint", () => {
      parts.forEach((part) => {
        postRequest.object("/print", { type: part.type, id: part.id });
      });
    });
    launchPrint();
  });
}

export default {
  components: {
    "qr-code": VueQrCode,
  },
  data: () => ({
    dialog: false,
    loading: false,
    parts: [],
    vehicle: null,
  }),
  watch: {
    dialog(value) {
      if (!value) this.close();
    },
  },
  methods: {
    open(data) {
      this.dialog = true;
      this.loading = true;
      const { vehicle, parts } = data;
      this.vehicle = vehicle;

      getRequest("/car/parts", `ids=${parts.toString()}`)
        .then((result) => {
          this.parts = result;
        })
        .catch(() => {})
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
      this.parts = [];
      this.vehicle = null;
      this.$emit("close");
    },
    print() {
      printMultipleQrCodes(
        this.vehicle,
        this.getSupplyLocale(this.vehicle.version.supplyCode),
        this.parts,
        this.$t.bind(this),
      );
    },
    printSingle(part) {
      printSingleQrCode(
        this.vehicle,
        this.getSupplyLocale(this.vehicle.version.supplyCode),
        part,
        this.$t.bind(this),
      );
    },

    getSupplyLocale(supply) {
      switch (supply) {
        case "B":
          return this.$t("parts.infoCar.supply.petrol");
        case "D":
          return this.$t("parts.infoCar.supply.diesel");
        case "G":
          return this.$t("parts.infoCar.supply.gas");
        default:
          return supply;
      }
    },
  },
};
</script>

<style scoped>
.parts-qr-title {
  display: flex !important;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  padding: 12px 16px;
  white-space: normal !important;
  overflow: visible;
  height: auto;
}

.parts-qr-title-row {
  position: relative;
  min-height: 36px;
  padding-right: 44px;
}

.parts-qr-title-label {
  flex: 1;
  min-width: 0;
}

.parts-qr-info {
  width: 100%;
  line-height: 1.45;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
}

.parts-qr-close-btn {
  position: absolute;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}

@media (max-width: 959.98px) {
  .parts-qr-actions {
    justify-content: center;
  }

  .parts-qr-actions .v-btn {
    width: 100%;
    max-width: 100%;
  }
}
</style>
